module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    ref: "keyword",
    staticClass: "keyword",
    class: {
      isNew: _vm.keyword.isNew, active: _vm.active, empty: !this.keyword.value
    },
    style: (_vm.style),
    on: {
      "mousedown": _vm.dragStart
    }
  }, [_vm._c('div', {
    staticClass: "tools"
  }, [_vm._c('i', {
    staticClass: "fa fa-close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.destroy($event)
      }
    }
  })]), _vm._v(" "), _vm._c('i', {
    staticClass: "resize-handle icon mdi mdi-texture",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.resizeStart($event)
      }
    }
  }), _vm._v(" "), _vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword.value),
      expression: "keyword.value"
    }],
    ref: "input",
    domProps: {
      "value": _vm._s(_vm.keyword.value)
    },
    on: {
      "click": _vm.focus,
      "change": _vm.change,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword.value = $event.target.value
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0087e392!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/micro-note-editor/ImageKeyword.vue
// module id = 611
// module chunks = 1